<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
  mounted() {
    // Fix iOS viewport height issue
    const setViewportHeight = () => {
      document.documentElement.style.setProperty(
        "--app-height",
        `${window.innerHeight}px`,
      );
    };

    // Set on mount
    setViewportHeight();

    // Update on resize (for when iOS Safari toolbar appears/disappears)
    window.addEventListener("resize", setViewportHeight);
    window.addEventListener("orientationchange", setViewportHeight);
  },
};
</script>

<style>
/* Global viewport fix */
:root {
  --app-height: 100vh; /* fallback */
}

/* Prefer modern dynamic viewport */
@supports (height: 100dvh) {
  :root {
    --app-height: 100dvh;
  }
}

html.lock-scroll,
body.lock-scroll {
  overflow: hidden;
}

/* Paint html/body with the active theme background so the 5px .home-page
   margin (and mobile overscroll) never exposes the default white. */
html,
body {
  background-color: var(--background-color);
}

.error-message {
  color: red;
  font-size: 12px;
  margin-top: 5px;
  display: block;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

.main-page {
  display: flex;
  flex-direction: column;
  height: var(--app-height);
}

.main-page h1,
.main-page p,
.main-page form,
.main-page div {
  width: 100%;
  text-align: left;
}

.main-header {
  background: linear-gradient(90deg, #0b3362 0%, #1768c8 100%);
  padding: 10px;
  color: white;
  text-align: center;
  font-size: 1.5em;
  border-bottom: 1px solid #ccc;
  height: calc(60px * 1.5);
  /* Increase height by 50% */
  display: flex;
  align-items: center;
  /* Center items vertically */
  justify-content: left;
}

.main-header .logo {
  height: 40px;
  margin-right: 2%;
}

.main-page-header-text {
  height: 40px;
  margin-top: 2%;
  margin-left: 20%;
}

.main-page-header-text {
  font-size: 1.5em;
  margin-top: 2%;
  margin-left: 0%;
  font-family: "Roboto", sans-serif;
}

/* SweetAlert2 app theme */
.app-swal-popup {
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 32rem;
}

.app-swal-title {
  color: var(--primary-color, #1f6dca);
  font-weight: 700;
}

.app-swal-body {
  color: #2c3e50;
}

.app-swal-actions {
  gap: 10px;
}

.app-swal-btn {
  border: none;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  font-weight: 600;
  min-width: 110px;
  padding: 10px 20px;
  transition: filter 0.15s ease;
}

.app-swal-btn:hover {
  filter: brightness(0.92);
}

.app-swal-btn-confirm {
  background-color: var(--primary-color, #1f6dca);
}

.app-swal-btn-cancel {
  background-color: #6c757d;
}

.app-swal-btn-deny {
  background-color: #ca1f67;
}

/* Icon colors tuned to app palette and scoped to alert popups only */
.swal2-popup.app-swal-popup .swal2-icon.swal2-success {
  border-color: #2a9d6f;
  color: #2a9d6f;
}

.swal2-popup.app-swal-popup .swal2-success-circular-line-left,
.swal2-popup.app-swal-popup .swal2-success-circular-line-right,
.swal2-popup.app-swal-popup .swal2-success-fix {
  background-color: transparent;
}

.swal2-popup.app-swal-popup .swal2-icon.swal2-warning {
  border-color: #b7791f;
  color: #b7791f;
}

.swal2-popup.app-swal-popup .swal2-icon.swal2-error {
  border-color: #ca1f67;
  color: #ca1f67;
}

.swal2-popup.app-swal-popup .swal2-icon.swal2-info,
.swal2-popup.app-swal-popup .swal2-icon.swal2-question {
  border-color: var(--primary-color, #1f6dca);
  color: var(--primary-color, #1f6dca);
}

@media (max-width: 768px) {
  .app-swal-popup {
    max-width: 90vw;
  }
}

@media (max-width: 480px) {
  .app-swal-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .app-swal-btn {
    min-width: unset;
    padding: 10px 14px;
    width: 100%;
  }
}
</style>
